var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8531CAEA-ADBA-425C-A509-57E5DAC99038") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wiki",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14-wiki--page-Details_With_Page_element",
    transform: "translate(-1478.000000, -7540.000000)",
    fill: "#FF5000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "h2",
    transform: "translate(574.000000, 3812.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(900.000000, 3724.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_arrow_in"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0003,12.5854864 L16.2928932,9.29289322 L17.7071068,10.7071068 L12,16.4142136 L6.29289322,10.7071068 L7.70710678,9.29289322 L11.0003,12.5860864 L11.0003,4 L13.0003,4 L13.0003,12.5854864 L13.0003,12.5854864 Z M20.0003,18.0066 L20.0003,20.0066 L4.0003,20.0066 L4.0003,18.0066 L20.0003,18.0066 Z",
    id: "shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDownload);
export default __webpack_public_path__ + "static/media/ico_download.1e4d62ad8b70e393aba245b89b2cd90d.svg";
export { ForwardRef as ReactComponent };